import React, { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import { Login } from '../pages/Login';
import { MainMenu } from '../pages/MainMenu';
import { Admin } from '../global/administrador/Admin';
import { Usuarios } from '../global/administrador/usuarios/Usuarios';
import { Document } from '../global/documentacion/Document';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import { Header } from '../global/Header';
import { Footer } from '../global/Footer';
import { Grid } from '@mui/material';

import { BtnSubir } from '../utils/BtnSubir';
import { RecursosHumanos } from '../global/rrhh/RecursosHumanos';
import { Cuadrillas } from '../global/cuadrillas/Cuadrillas';
import { Personas } from '../global/documentacion/Personas';
import { Carpetas } from '../global/documentacion/Carpetas';
import { Documentos } from '../global/documentacion/Documentos';

// colores de los componentes del MUI
const theme = createTheme({
	palette: {
		primary: {
			main: '#384314',
		},
		secondary: {
			main: '#c8d11d',
		},
		blanco: {
			main: '#F5F7F8'
		}
	},
});

const Router = () => {
	//global
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [openDrawer, setOpenDrawer] = useState(
		localStorage.getItem('openDrawer') === 'true'
	);

	useEffect(() => {
		localStorage.setItem('openDrawer', openDrawer);
	}, [openDrawer]);

	return (
		<BrowserRouter> {/* Añade BrowserRouter aquí */}
			<ThemeProvider theme={theme}>
				<div className='back-main fade-in'>
					<Grid container size={{ xs: 12 }} direction={'column'}>
						<Grid container size={{ xs: 12 }} direction={'row'}>
							<Header setOpenDrawer={setOpenDrawer} openDrawer={openDrawer} />
						</Grid>
						<Grid container size={{ xs: 12 }} direction={'row'}>
							<Grid container size={{ xs: 12 }} sx={{ pb: 10 }}>
								<Grid container size={{ xs: 12 }} direction={'row'}>
									<Grid container size={{ xs: 12 }} direction={'column'}>
										<Routes>
											<Route element={<PrivateRoute />}>
												<Route path="/" element={<MainMenu />}></Route>

												{/* //recursos humanos */}
												<Route path="/rrhh" element={<RecursosHumanos />}></Route>

												{/* //jornadas */}
												{/* <Route path="/jornadas" element={<Jornadas />}></Route> */}

												{/* //tareas */}
												{/* //calendario */}
												{/* <Route path="/calendario" element={<Calendario />}></Route> */}

												{/* //admin */}
												<Route path="/admin" element={<Admin />}></Route>

												{/* //Cuadrillas */}
												<Route path="/cuadrillas" element={<Cuadrillas />}></Route>

												{/* //usuarios */}
												<Route path="/usuarios" element={<Usuarios />}></Route>

												
												{/* //documentos */}
												<Route path="/documentos" element={<Document />}></Route>

												{/* //personas */}
												<Route path="/personas" element={<Personas />}></Route>

												{/* //carpetas */}
												<Route path="/carpetas" element={<Carpetas />}></Route>

												{/* //documentos */}
												<Route path="/documentacion" element={<Documentos />}></Route>

												{/* //departamentos */}
												{/* <Route path="/rolesydepartamentos" element={<RolesYDepartamentos />}></Route> */}

												{/* //notificaciones */}
												{/* <Route path="/notificaciones" element={<Notificaciones />}></Route> */}

												{/* //fichajes */}
												{/* <Route path="/fichajes" element={<Fichajes />}></Route>

												<Route path="/fichajesusuario/:id" element={<FichajesUsuario />}></Route> */}

											</Route>
											{/* //global */}
											<Route path="/login?" element={<Login username={username} setUsername={setUsername} password={password} setPassword={setPassword} />}></Route>
											<Route path="*" element={<Navigate to="/" replace />} />
										</Routes>
									</Grid>

								</Grid>
							</Grid>
							<BtnSubir></BtnSubir>
							<Footer></Footer>
						</Grid>
					</Grid>
				</div>
			</ThemeProvider>
		</BrowserRouter>
	)
}

export default Router